import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerTiktokProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerTiktokProfileOverview = (props: InfluencerTiktokProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
